import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import db from "./Firebase";
import * as XLSX from "xlsx";
import Moment from "moment";
import { extendMoment } from "moment-range";

function RequestedWorkshops() {
    const moment = extendMoment(Moment);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");
        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate("/signin");
        }
    }, []);

    useEffect(() => {
        const q = query(collection(db, "nv_requested_topics"), orderBy("created_date", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setData(snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() })));
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const filtered = data.filter(({ data }) => {
        const q = searchQuery.toLowerCase();
        return (
            (data.full_name || "").toLowerCase().includes(q) ||
            (data.phone_no || "").includes(q) ||
            (data.message || "").toLowerCase().includes(q)
        );
    });

    const exportToExcel = () => {
        const rows = filtered.map(({ data }, i) => ({
            "#": i + 1,
            "Full Name": data.full_name || "",
            "Phone No": data.phone_no || "",
            "Message": data.message || "",
            "Created Date": data.created_date
                ? moment(data.created_date.toDate()).format("DD MMM YYYY, h:mm a")
                : "",
        }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), "Requested Workshops");
        XLSX.writeFile(wb, "requested_workshops.xlsx");
    };

    return (
        <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
            <div className="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card">
                    <div className="card-header pb-0 px-3">
                        <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                            <h6 className="mb-0">Requested Workshops ({filtered.length})</h6>
                            <div className="d-flex gap-2 align-items-center flex-wrap">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search by name, phone or message..."
                                    style={{ maxWidth: "280px" }}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <button
                                    className="btn bg-gradient-secondary btn-sm text-white"
                                    onClick={exportToExcel}
                                    disabled={filtered.length === 0}
                                >
                                    Download Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-hover" style={{ fontSize: "13px" }}>
                            <thead className="thead-dark" style={{ position: "sticky", top: 0 }}>
                                <tr>
                                    <th>#</th>
                                    <th>Full Name</th>
                                    <th>Phone No</th>
                                    <th>Message</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
                                            <p className="text-xs mt-2 mb-0" style={{ color: "#7b809a" }}>Loading...</p>
                                        </td>
                                    </tr>
                                ) : filtered.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">
                                            {searchQuery ? "No results found" : "No data available"}
                                        </td>
                                    </tr>
                                ) : filtered.map(({ id, data }, index) => (
                                    <tr key={id}>
                                        <td>{index + 1}</td>
                                        <td className="text-xs font-weight-bold">{data.full_name || "-"}</td>
                                        <td className="text-xs">{data.phone_no || "-"}</td>
                                        <td className="text-xs" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxWidth: "320px" }}>{data.message || "-"}</td>
                                        <td className="text-xs" style={{ whiteSpace: "nowrap" }}>
                                            {data.created_date
                                                ? moment(data.created_date.toDate()).format("DD MMM YYYY, h:mm a")
                                                : "-"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default RequestedWorkshops;
